var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-md-editor',{attrs:{"disabled":true,"disabled-menus":[],"autofocus":true,"right-toolbar":_vm.rightToolbarList,"toolbar":_vm.extraToolbars,"left-area-visible":true},on:{"upload-image":_vm.onImageUpload,"save":_vm.save},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }